import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { KironPlayerComponent } from '../../../alert/kiron-player/kiron-player.component';
import { BettingServiceService } from "../../../../services/betting_service/betting-service.service";
import { CommonServiceService } from '../../../../services/common_service/common-service.service';
import { StmgService } from '../../../../services/state_Management/stmg.service';
import { AlertController } from '@ionic/angular';
import { AlertComponent } from '../../../../components/alert/alert.component';

import { Subscription } from 'rxjs';
import { interval } from 'rxjs';
import { PlayerModalComponent } from 'src/app/components/alert/player-modal/player-modal.component';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-nova',
  templateUrl: './nova.component.html',
  styleUrls: ['./nova.component.scss'],
})
export class NovaComponent implements OnInit {


  next10 = false;
  kironResults: any = [];
  meeting_data: any;
  meeting_details: any = [];
  reload_time: number;

  kironNewData: any;

  Kiron2VideoUrl: any;
  is_logged = false;

  meetingPayload = {
    country: 'KR2',
    date: this.commanService.getCurrentDateTime(),
    filter: 1,
    inplay: false,
    sport: 'VR',
  }

  subscription: Subscription;
  disable_SP_subscription: Subscription;
  videoPopup: HTMLIonModalElement;

  currentSelectedBets: any = null;    // Block Games

  constructor(public modalController: ModalController, public betting_service: BettingServiceService, public translate: TranslateService,
    private commanService: CommonServiceService, private stmgService: StmgService, public alertController: AlertController,) {

    //refresh when remove all from bet slip modal
    this.disable_SP_subscription = this.commanService.getClickEvent().subscribe(() => {
      this.kironNewData.forEach(meeting => {
        meeting.selections.forEach(selection => {
          selection.clicked=false
        });
      });
    })
  }

  mySubscription: Subscription;

  ngOnInit() {

    this.get_kiron_results();
    //this.get_meeting_data();  

    // get Kiron Meetings
    this.kiron_getMeetings();

    this.stmgService.is_logged_status.subscribe(message =>
      this.is_logged = message
    );

    this.subscription = this.stmgService.cast_selectedBets.subscribe(selectedBets => {
      if (selectedBets) {
        this.selection = selectedBets;
      }

    });

    // Block Games
    this.stmgService.cast_selectedBets.subscribe(bets => {
      this.currentSelectedBets = bets;
      // console.log('Game - Subscription updated:', bets);
    });

  }

  //kiron result method
  get_kiron_results() {
    this.betting_service.getKiron2Result().subscribe(
      (data) => {
        this.kironResults = data;
        this.kironResults = this.kironResults.reverse();
      },
      (error) => {
        //console.log(error);
      }
    );
  }

  // get Kiron Meetings
  kiron_getMeetings() {
    this.betting_service.getMeetingData(this.meetingPayload).subscribe((data: any) => {
      this.kironGetEventStartTime(data.payload[0].eventLightDTOs);
      this.kiron_data(data);
    });
  }

  kiron_data(d: any) {
    let kironMeetings_Data = [];
    if (d.status == 'success') {
      if (d.payload.length > 0) {
        for (let i = 0; i < d.payload[0].eventLightDTOs.length; i++) {
          kironMeetings_Data.push(d.payload[0].eventLightDTOs[i])
        }
      };
      this.getKironsEventByID(kironMeetings_Data);
    }
  };


  getKironsEventByID(d: any) {
    let kironEventresult = d;
    kironEventresult.forEach(event => {
      if (event.id != undefined) {
        event.selections=[]
        this.betting_service.getEventSelections(event.id).subscribe((data) => {
          event.selections = data;
        })
      }
    });
    this.kironNewData = kironEventresult
  }


  kironGetEventStartTime(meeting) {
    this.betting_service.eventStartTime(meeting[0].id).subscribe((data) => {
      this.kironEventStartTime(data);
    }
    );
  }

  kironEventStartTime(data) {

    let time: any;

    time = data.timeToStartMillis;
    time = time / 1000;
    time = Math.round(time);


    this.mySubscription = interval(1000).subscribe((x => {
      if (time < 0) {
        this.kiron_getMeetings();
        this.mySubscription.unsubscribe();
      } else {

        if (time != 0 || time > 0) {

        } else {
          this.kiron_getMeetings();
          this.mySubscription.unsubscribe();
        }

      }
      time--;

    }));

  }



  //open video player
  async open_player() {
    const modal = await this.modalController.create({
      component: PlayerModalComponent,
      cssClass: 'customPopup',
      componentProps: { videoUrl: this.Kiron2VideoUrl }
    });
    this.videoPopup = modal;
    modal.onDidDismiss().then(data => {
      this.videoPopup = null
    })
    return await modal.present();
  }

  //video button click function
  video_clicked() {
    if (this.is_logged) {
      //get kiron dg video
      this.betting_service.getKiron2VideoUrl(this.commanService.getToken()).subscribe(
        (data) => {
          //console.log(data['url']);
          this.Kiron2VideoUrl = data['url'];
          //only open one popup
          if (!this.videoPopup || this.videoPopup == null) {
            this.open_player()
          }
        },
        (error) => {
          //console.log(error);
        }
      );

    }
    else {
      let alertTitle: string;
      let alertDesc: string;
      this.translate.get('ALERTS.LOGTO_VIDEO.TITLE').subscribe((res: string) => {
        alertTitle = res;
      });
      this.translate.get('ALERTS.LOGTO_VIDEO.DESC').subscribe((res: string) => {
        alertDesc = res;
      });
      let alert = new AlertComponent(this.alertController);
      alert.loginSuccessAlert("", alertTitle, alertDesc);
    }

  }


  //stop the loop
  ngOnDestroy() {
    this.mySubscription?.unsubscribe();
    console.log("unsubsccribe")
    this.disable_SP_subscription.unsubscribe();
  }


  selectionType: string = "";
  maxCount: boolean = false;
  //method for SP buttons
  setSPOdd(value: any) {
    this.selectionType = 'SP';
    value.clicked = !value.clicked;
    value.fr_clicked = false;

    if (value.clicked == true) {
      this.maxCount = this.checkMaximuSelectionCount();
      if (this.maxCount == false) {
        this.placeBetObj(value, this.selectionType);
      } else {
        value.clicked = false;
        this.showMaxCountAlert();
      }
    } else {
      this.placeBetObj(value, this.selectionType);
    }

  }


  selection: any = {
    eventSelections: []
  };

  // checkMaximuSelectionCount() {
  //   let val: boolean;
  //   let selectionArray = this.selection.eventSelections.filter(m => !m.isKR3)
  //   if (selectionArray.length == 4) {
  //     val = true;
  //   } else {
  //     val = false;
  //   }
  //   return val;
  // }

  checkMaximuSelectionCount(): boolean {

    if (!this.selection || !this.selection.eventSelections) {
      return false;
    }

    const selectionArray = this.selection.eventSelections.filter(m => !m?.isKR3);

    return selectionArray.length === 4;
  }

  placeBetObj(d: any, t: string) {

    // Block Games Selections
    if (!this.selection) {
      this.selection = { eventSelections: [] };
    }
    if (!this.selection.eventSelections) {
      this.selection.eventSelections = [];
    }

    // **CHECK if game bets exist**
    if (this.currentSelectedBets && this.currentSelectedBets !== '') {
      console.log('Nova - Inside check, currentBets exists');
      
      const isKironGame = this.currentSelectedBets.payload && (this.currentSelectedBets.payload['@rule'] === 'FeedId88BettingOptions' || this.currentSelectedBets.payload['@rule'] === 'FeedId86BettingOptions' || this.currentSelectedBets.payload['@rule'] === 'FeedId87BettingOptions');
      console.log('Nova - isKironGame:', isKironGame);
      
      if (isKironGame && this.currentSelectedBets.payload.eventSelections) {
        const hasGameBets = this.currentSelectedBets.payload.eventSelections.length > 0;
        console.log('Nova - hasGameBets:', hasGameBets);
        
        if (hasGameBets) {
          this.showBlockAlert();
          d.clicked = false;
          d.fr_clicked = false;
          return;
        }
      }
    }

    let oddD: any;
    let oddF: any;
    let win: number = 0;
    let place: number = 0;


    switch (t) {

      case 'SP':
        oddF = 'N';
        oddD = 0.0;
        break;

      case 'PO':
        oddF = d.priceOdds.priceFraction;
        oddD = 0.0;
        break;

      case 'PD':
        oddF = 'N';
        oddD = d.priceOdds.priceDecimal;
        break;

    }

    let tempObj = {
      id: d.id,
      oddD: oddD,
      oddF: oddF,
      win: win,
      place: place,
      sportType: d.id
    }

    if (t == "SP") {
      if (d.clicked == true) {
        this.maxCount = this.checkMaximuSelectionCount();
        let index = -1;
        for (let i = 0; i < this.selection.eventSelections.length; i++) {

          if (this.selection.eventSelections[i].id == d.id) {
            index = i;
            //remove old row
            this.selection.eventSelections.splice(index, 1);
            //add new row
            this.selection.eventSelections.push(tempObj);
            break;
          }

        }

        // add row
        if (index == -1) {
          this.selection.eventSelections.push(tempObj);
        }


      } else {
        let index = -1;
        for (let i = 0; i < this.selection.eventSelections.length; i++) {

          if (this.selection.eventSelections[i].id == d.id) {
            index = i;
            // remove row
            this.selection.eventSelections.splice(index, 1);
            break;
          }

        }
      }

    }



    if (t == "PO") {
      if (d.fr_clicked == true) {
        this.maxCount = this.checkMaximuSelectionCount();
        let index = -1;
        for (let i = 0; i < this.selection.eventSelections.length; i++) {
          if (this.selection.eventSelections[i].id == d.id) {
            index = i;
            //remove old row 
            this.selection.eventSelections.splice(index, 1);
            //add new row
            this.selection.eventSelections.push(tempObj);
            break;
          }

        }

        // add row
        if (index == -1) {
          this.selection.eventSelections.push(tempObj);
        }


      } else {
        let index = -1;
        for (let i = 0; i < this.selection.eventSelections.length; i++) {
          if (this.selection.eventSelections[i].id == d.id) {
            index = i;
            // remove row
            this.selection.eventSelections.splice(index, 1);
            break;
          }

        }
      }
    }

    //console.log(this.selection);

    this.stmgService.updateSelecteBets(this.selection);
  }


  showMaxCountAlert() {
    let alertTitle: string;
    let alertDesc: string;
    this.translate.get('ALERTS.MAX_COUNT.TITLE').subscribe((res: string) => {
      alertTitle = res;
    });
    this.translate.get('ALERTS.MAX_COUNT.DESC').subscribe((res: string) => {
      alertDesc = res;
    });
    let alert = new AlertComponent(this.alertController);
    alert.launchAlert("", alertTitle, alertDesc);
  }

  // Block Slecetion with Games
  showBlockAlert() {
    let alertTitle: string;
    let alertDesc: string;
    this.translate.get('ALERTS.BLOCK_SELECTIONS.TITLE').subscribe((res: string) => {
      alertTitle = res;
    });
    this.translate.get('ALERTS.BLOCK_SELECTIONS.DESC').subscribe((res: string) => {
      alertDesc = res;
    });
    let alert = new AlertComponent(this.alertController);
    alert.launchAlert("", alertTitle, alertDesc);
  }

}
